/* eslint-disable react/destructuring-assignment */
import React from "react";
import PropTypes from "prop-types";

import logo from "../../assets/images/logo.png";

import "./LoginLayout.scss";
import { LayoutCard, LogoContainer } from "./styles";

const LoginLayout = ({ children }) => (
  <>
    <div className="page-wrapper">
      <div className="container-fluid p-0">
        <div className="authentication-main">
          <div className="row">
            <LogoContainer>
              <img src={logo} alt="Logo" width="100%" />
            </LogoContainer>
            <div className="col-md-12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <LayoutCard className="card mb-0">
                    <div className="card-body p-0">{children}</div>
                  </LayoutCard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

LoginLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default LoginLayout;
